import React from 'react';

import * as styles from './index.module.scss';

const AccordionItem = ({
    title,
    children, 
    condensed, 
    hasMetaScopeAttributes = false, 
    simplifiedGreen = false,
    noGap = false,
    colourVariant = 'default' // 'default', 'primary', 'orange'
}) => {
    return (
        <li className={`${styles.accordionItem} ${condensed ? styles.small : ''}`} {...(hasMetaScopeAttributes ? { itemScope: true, itemType: "http://schema.org/Question" } : {})}>
            <details className={styles.accordionDetails}>
                <summary 
                    className={`${styles.accordionItemTitle} ${!simplifiedGreen ? styles.accordionItemTitleVerbose : ''} ${colourVariant !== 'default' ? styles[`accordionItemTitle${colourVariant.charAt(0).toUpperCase() + colourVariant.slice(1)}`] : ''}`}
                    {...(hasMetaScopeAttributes ? { itemProp: "name" } : {})}
                >
                    <span {...(hasMetaScopeAttributes ? { itemProp: "text" } : {})}>{title}</span>
                </summary>
                <div 
                    className={`${styles.accordionItemContent} ${!simplifiedGreen ? styles.accordionItemContentVerbose : ''}`}
                    {...(hasMetaScopeAttributes ? { itemProp: "acceptedAnswer" } : {})}
                >
                    <div {...(hasMetaScopeAttributes ? { itemProp: "text" } : {})} className={noGap ? '' : styles.accordionItemChildren}>
                        {children}
                    </div>
                </div>
            </details>
        </li>
    );
}

export default AccordionItem;